import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BaseService } from '../base.service';
import { MinDTO } from 'src/app/models/min-dto';


@Injectable()
export class AirportService extends BaseService<any>{
    constructor(public httpClient: HttpClient) {
        super(
            'air',
            httpClient);
    }

    autocomplete = this.searchAirport;

    searchAirport(params): Observable<MinDTO[]> {
        let uri = new URL(environment.baseUrl + `/air/port`).updateQueryParam(params);

        return this.httpClient.get<MinDTO[]>(uri.toString(), { withCredentials: false, headers: this.httpHeaders() })
            .pipe(
                tap(),
                catchError(this.handleError)
            )
    }


}
